import IconSamsungGalxyBuds from '@/assets/images/samsung/icon-samsung-galaxy-buds.svg';
import IconSamsungGalxySamrtphones from '@/assets/images/samsung/icon-samsung-galaxy-smartphone.svg';
import IconSamsungGalxyWatch from '@/assets/images/samsung/icon-samsung-galaxy-watch.svg';
import type { Promotion } from '@/lib/offers-by-group';

const imagePath = '/content/content-images/landingpages/samsung';
const videoPath = '/content/content-videos/landingpages/samsung';

export const STAGE_DATA = {
  mainTitle: 'Die Samsung Galaxy Family für den ganzen Tag',
  description:
    'Samsung-Galaxy-Geräte arbeiten einfach zusammen, damit Du es leicht hast: Vom Aufstehen bis zum Feierabend – egal, was der Tag bringt. Deine smarten Begleiter sind nicht nur untereinander vernetzt, sondern sie verbinden Dich auch jederzeit mit Deinen Freunden und Deiner Familie.',
  products: [
    {
      alt: 'Galaxy Watch7',
      src: `${imagePath}/stage/fcb35328d844fa438a8871e730bda43e/samsung-galaxy-watch7@2x.png`,
      aspectRatio: 96 / 97,
      ref: 'galaxyWatch7',
      positionY: {
        desktop: 5,
        mobile: 15,
      },
      plusIcon: {
        title: 'Samsung Galaxy Watch7',
        label: 'Mehr erfahren',
        ariaLabel: 'Mehr über Samsung Galaxy Watch7 erfahren',
      },
    },
    {
      alt: 'Samsung S25',
      src: `${imagePath}/stage/e55b2f3043737420ffc98951421c3e72/samsung-s25@2x.png`,
      aspectRatio: 192 / 413,
      ref: 'samsungS25',
      positionY: {
        desktop: 2,
        mobile: 10,
      },
      plusIcon: {
        title: 'Samsung S25',
        label: 'Mehr erfahren',
        ariaLabel: 'Mehr über Samsung S25 erfahren',
        xsOpenLeft: true,
        smOpenLeft: false,
      },
    },

    {
      alt: 'Samsung S25+',
      src: `${imagePath}/stage/544d91315c9dc48aa911923056c12190/samsung-s25+@2x.png`,
      aspectRatio: 4 / 9,
      ref: 'samsungS25Plus',
      positionY: {
        desktop: 5,
        mobile: 20,
      },
      plusIcon: {
        title: 'Samsung S25+',
        label: 'Mehr erfahren',
        ariaLabel: 'Mehr über Samsung S25+ erfahren',
        xsOpenLeft: false,
        smOpenLeft: false,
      },
    },
    {
      alt: 'Samsung S25 Ultra',
      src: `${imagePath}/stage/a78b907cb46c51dc70a064f9a2c516b1/samsung-s25-ultra@2x.png`,
      aspectRatio: 192 / 329,
      ref: 'samsungS25Ultra',
      positionY: {
        desktop: 10,
        mobile: 15,
      },
      plusIcon: {
        title: 'Samsung S25 Ultra',
        label: 'Mehr erfahren',
        ariaLabel: 'Mehr über Samsung S25 Ultra erfahren',
        xsOpenLeft: true,
        smOpenLeft: true,
        mdOpenLeft: true,
      },
    },
    {
      alt: 'Samsung Galaxy Buds3 Pro',
      src: `${imagePath}/stage/f0504eab08c4c6749de233969c06ee21/samsung-galaxy-buds3pro@2x.png`,
      aspectRatio: 384 / 425,
      ref: 'galaxyBuds3',
      positionY: {
        desktop: 10,
        mobile: 20,
      },
      plusIcon: {
        title: 'Samsung Galaxy Buds3 Pro',
        label: 'Mehr erfahren',
        ariaLabel: 'Mehr über Samsung Galaxy Buds3 Pro erfahren',

        smOpenLeft: true,
        mdOpenLeft: true,
      },
    },
  ],
};

export const SMARTPHONES_GALAXY_FAMILY = {
  rowReverse: false,
  title: {
    label: 'Entdecke die Top-Smartphones der Galaxy Family',
    tag: 'h2',
  },
  copy: 'Leistungsstarke Kameras und edles Design.',
  cta: {
    label: 'Top Smartphones entdecken',
    tag: 'nuxt-link',
    to: '/smartphones-und-handys/smartphones/_samsung',
  },
  video: {
    // Customer has to proof the video source from samsung
    // src: `${videoPath}/a69fe08df23f968c29fad19dc7b398fd/samsung-fold4-flip4.mp4`,
    // poster: `${imagePath}/hero-videos/dffd0ba6388cc44cfb2619f8cd235c2c/poster_Galaxy_Buds2_Pro_Animation_20s_16x9.webp`,
  },
  imageFallback: {
    ariaHidden: true,
    alt: '',
    src: `${imagePath}/hero-teaser/samsung-smartphone-teaser-group-opt/89b657ba07569fffd193e2f839221e49/samsung-video-fallback-opt.webp`,
  },
  hero: {
    align: 'center',
    src: `${imagePath}/hero-teaser/94eb4bb1572c2778ad91dad21f744cb3/top-galaxy-smartphones-update-07-2024@2x.png`,
    alt: 'Die Samsung Galaxy S25, S25+ und S25 Modelle, nebeneinander dargestellt.',
    animationProduct: {
      start: 'top bottom',
      end: 'center center',
      vars: { y: 150 },
    },
  },
};

export const WATCHES_GALAXY_FAMILY = {
  rowReverse: true,
  title: {
    label: 'Die smarten Watches aus der Galaxy Family',
    tag: 'h2',
  },
  copy: 'Vielseitige Fitness- und Gesundheitsfunktionen für einen bewussten Lebensstil und mobile Erreichbarkeit in einem.',
  cta: {
    label: 'Top Watches entdecken',
    tag: 'nuxt-link',
    to: '/wearables/smartwatches/_samsung',
  },
  video: {
    src: `${videoPath}/0e926e45abbf37c71b6005ddfdff8cec/Galaxy_Watch7_Animation.webm`,
    poster: `/_ipx/f_webp,w_640/content/content-images/landingpages/samsung/hero-videos/8abd8c123e164b3991eb4f0419766cf1/samsung-galaxy-watch-7.png`,
  },
};

export const COMPARISON_WATCHES = {
  title: 'Die perfekte Watch für Dich',
  copy: 'Vergleiche hier die Top-Features unserer Galaxy Watch Modelle',
  items: [
    {
      title: 'Galaxy Watch7',
      headingTag: 'h4',
      products: [
        {
          alt: 'Galaxy Watch7 - green',
          colorName: 'Green',
          src: `${imagePath}/vergleichstabelle-watch/galaxy-watch-7/galaxy-watch-7-green/f7d0a9eaec60baf361d19e8dd349fe35/galaxy-watch7-klein-green@2x.png`,
          tileGroups: ['comparison_watches'],
          articleNumber: '8806095661797',
          color: '#89D63D',
        },
        {
          alt: 'Galaxy Watch7 - cream',
          colorName: 'Cream',
          src: `${imagePath}/vergleichstabelle-watch/galaxy-watch-7/galaxy-watch-7-cream/867ef7e31a1ca570067b5972da575fa9/galaxy-watch7-klein-cream@2x.png`,
          tileGroups: ['comparison_watches'],
          articleNumber: '8806095662121',
          color: '#E7CDB0',
        },
      ],
      productsBig: [
        {
          alt: 'Galaxy Watch7 - green',
          colorName: 'Green',
          src: `${imagePath}/vergleichstabelle-watch/galaxy-watch-7/galaxy-watch-7-green/acc3b980496135a7001598d2c9a70481/galaxy-watch7-gross-green@2x.png`,
          tileGroups: ['comparison_watches'],
          articleNumber: '8806095660547',
          color: '#89D63D',
        },
        {
          alt: 'Galaxy Watch7 - silver',
          colorName: 'Silver',
          src: `${imagePath}/vergleichstabelle-watch/galaxy-watch-7/galaxy-watch-7-silver/f41d5f1d239b8118fe47d6042ce924a5/galaxy-watch7-gross-silver@2x.png`,
          tileGroups: ['comparison_watches'],
          articleNumber: '8806095660721',
          color: '#D0D0D0',
        },
      ],
      values: [
        {
          title: 'Größe',
          content: '40mm',
          checked: false,
        },
        {
          title: 'Gewicht',
          content: '28,8 g',
          checked: false,
        },
        {
          title: 'Display',
          content: 'Super AMOLED',
          checked: false,
        },
        {
          title: 'Material',
          content: 'Aluminium',
          checked: false,
        },
        {
          title: 'Akku(typisch)',
          content: '300 mAh',
          checked: false,
        },
        {
          title: 'Schlafanalyse',
          content: '',
          checked: true,
        },
        {
          title: 'Körperzusammensetzung',
          content: '',
          checked: true,
        },
        {
          title: 'Route workout / Track Back',
          content: '',
          checked: true,
        },
        {
          title: 'Robustheit',
          content: 'IP68, 5 ATM, MIL-STD-810H',
          checked: false,
        },
        {
          title: 'Fast charge',
          content: '',
          checked: true,
        },
      ],
    },
    {
      title: 'Samsung Galaxy Watch Ultra',
      headingTag: 'h4',
      products: [
        {
          alt: 'Samsung Galaxy Watch Ultra - Titanium Gray',
          colorName: 'Titanium Gray',
          src: `${imagePath}/vergleichstabelle-watch/galaxy-watch-ultra/galaxy-watch-ultra-gray/e6a07cc46be6b564957f24c5f50f9e3e/galaxy-watch-ultra-titanium-gray@2x.png`,
          tileGroups: ['comparison_watches'],
          articleNumber: '8806095687964',
          color: '#6C6C6C',
        },
        {
          alt: 'Samsung Galaxy Watch Ultra - Titanium Silver',
          colorName: 'Titanium Silver',
          src: `${imagePath}/vergleichstabelle-watch/galaxy-watch-ultra/galaxy-watch-ultra-silver/6d2309d88cb0cb9318653c22353bc6d9/galaxy-watch-ultra-titanium-silver@2x.png`,
          tileGroups: ['comparison_watches'],
          articleNumber: '8806095687933',
          color: '#D0D0D0',
        },
        {
          alt: 'Samsung Galaxy Watch Ultra - Titanium White',
          colorName: 'Titanium White',
          src: `${imagePath}/vergleichstabelle-watch/galaxy-watch-ultra/galaxy-watch-ultra-white/5c93f4b3f48ccdd2d7cdb74345a37f46/galaxy-watch-ultra-titanium-white@2x.png`,
          tileGroups: ['comparison_watches'],
          articleNumber: '8806095687902',
          color: '#FFFFFF',
        },
      ],
      values: [
        {
          title: 'Größe',
          content: '47mm',
          checked: false,
        },
        {
          title: 'Gewicht',
          content: '60,5 g',
          checked: false,
        },
        {
          title: 'Display',
          content: 'Super AMOLED',
          checked: false,
        },
        {
          title: 'Material',
          content: 'Titan',
          checked: false,
        },
        {
          title: 'Akku(typisch)',
          content: '590 mAh',
          checked: false,
        },
        {
          title: 'Schlafanalyse',
          content: '',
          checked: true,
        },
        {
          title: 'Körperzusammensetzung',
          content: '',
          checked: true,
        },
        {
          title: 'Route workout / Track Back',
          content: '',
          checked: true,
        },
        {
          title: 'Robustheit',
          content: 'IP68, MIL-STD-810H, 10 ATM',
          checked: false,
        },
        {
          title: 'Fast charge',
          content: '',
          checked: true,
        },
      ],
    },
    {
      title: 'Galaxy Watch6',
      headingTag: 'h4',
      products: [
        {
          alt: 'Galaxy Watch6 - graphite',
          colorName: 'Graphite',
          src: `${imagePath}/vergleichstabelle-watch/galaxy-watch-6/galaxy-watch-6-graphite/fd2eb264c456b2b248991ef9658658f3/galaxy-watch-6-klein-graphite@2x.png`,
          articleNumber: '8806095039428',
          slug: '/wearables/smartwatches/_samsung',
          color: '#6c6c6c',
        },
        {
          alt: 'Galaxy Watch6 - gold',
          colorName: 'Gold',
          src: `${imagePath}/vergleichstabelle-watch/galaxy-watch-6/galaxy-watch-6-gold/2ca353ab61285666c267c8be6a988fe1/galaxy-watch-6-klein-gold@2x.png`,
          articleNumber: '8806095058351',
          color: '#e7cdb0',
        },
      ],
      productsBig: [
        {
          alt: 'Galaxy Watch6 - graphite',
          src: `${imagePath}/vergleichstabelle-watch/galaxy-watch-6/galaxy-watch-6-graphite/f87b63aee52fec90efec308250e2888d/galaxy-watch-6-gross-graphite@2x.png`,
          colorName: 'Graphite',
          articleNumber: '8806095039381',
          color: '#6c6c6c',
        },
        {
          alt: 'Galaxy Watch6 - silver',
          colorName: 'Silver',
          src: `${imagePath}/vergleichstabelle-watch/galaxy-watch-6/galaxy-watch-6-silver/c749bebdabee43ee24d9121bdefd13d2/galaxy-watch-6-gross-silver@2x.png`,
          articleNumber: '8806095059273',
          color: '#EFEFEF',
        },
      ],
      values: [
        {
          title: 'Größe',
          content: '44mm | 40mm',
          checked: false,
        },
        {
          title: 'Gewicht',
          content: '33,3 g  | 28,7 g',
          checked: false,
        },
        {
          title: 'Display',
          content: 'Saphirglas',
          checked: false,
        },
        {
          title: 'Material',
          content: 'Aluminium',
          checked: false,
        },
        {
          title: 'Akku(typisch)',
          content: '425mAh |  300mAh',
          checked: false,
        },
        {
          title: 'Schlafanalyse',
          content: '',
          checked: true,
        },
        {
          title: 'Körperzusammensetzung',
          content: '',
          checked: true,
        },
        {
          title: 'Route workout / Track Back',
          content: '',
          checked: false, // RETURNS: -
        },
        {
          title: 'Robustheit',
          content: '5ATM+IP68/MIL-STD-810H',
          checked: false,
        },
        {
          title: 'Fast charge',
          content: '',
          checked: true,
        },
      ],
    },
    {
      title: 'Galaxy Watch6 Classic',
      headingTag: 'h4',
      products: [
        {
          alt: 'Galaxy Watch6 Classic - black',
          colorName: 'Black',
          src: `${imagePath}/vergleichstabelle-watch/galaxy-watch-6-classic/galaxy-watch-6-classic-black/6a4d6bf1b5b47edcc4821f36d9ea490d/galaxy-watch-6-classic-klein-black@2x.png`,
          articleNumber: '8806095058405',
          color: '#000',
        },
        {
          alt: 'Galaxy Watch6 Classic - silver',
          colorName: 'Silver',
          src: `${imagePath}/vergleichstabelle-watch/galaxy-watch-6-classic/galaxy-watch-6-classic-silver/9790d63a4e195ad0bf2af6fd84a28e45/galaxy-watch-6-classic-klein-silver@2x.png`,
          articleNumber: '8806095076249',
          color: '#D0D0D0',
        },
      ],
      productsBig: [
        {
          alt: 'Galaxy Watch6 Classic - black',
          colorName: 'Black',
          src: `${imagePath}/vergleichstabelle-watch/galaxy-watch-6-classic/galaxy-watch-6-classic-black/8a3f6d4b21de174fc3b8733dac0aa5f7/galaxy-watch-6-classic-gross-black@2x.png`,
          articleNumber: '8806095038841',
          color: '#000000',
        },
        {
          alt: 'Galaxy Watch6 Classic - silver',
          colorName: 'Silver',
          src: `${imagePath}/vergleichstabelle-watch/galaxy-watch-6-classic/galaxy-watch-6-classic-silver/bdb5a2f597a94e86d511a25ab25948bc/galaxy-watch-6-classic-gross-silver@2x.png`,
          articleNumber: '8806095038797',
          color: '#D0D0D0',
        },
      ],
      values: [
        {
          title: 'Größe',
          content: '47mm  |  43mm',
          checked: false,
        },
        {
          title: 'Gewicht',
          content: '59 g  | 52 g',
          checked: false,
        },
        {
          title: 'Display',
          content: 'Saphirglas',
          checked: false,
        },
        {
          title: 'Material',
          content: 'Edelstahl',
          checked: false,
        },
        {
          title: 'Akku(typisch)',
          content: '425mAh | 300mAh',
          checked: false,
        },
        {
          title: 'Schlafanalyse',
          content: '',
          checked: true,
        },
        {
          title: 'Körperzusammensetzung',
          content: '',
          checked: true,
        },
        {
          title: 'Route workout / Track Back',
          content: '',
          checked: false, // RETURNS: -
        },
        {
          title: 'Robustheit',
          content: '5ATM+IP68/MIL-STD-810H',
          checked: false,
        },
        {
          title: 'Fast charge',
          content: '',
          checked: true,
        },
      ],
    },
  ],
};

export const SAMSUNG_GALAXY_BUDS = {
  rowReverse: false,
  title: {
    label: 'Samsung Galaxy Buds',
    tag: 'h2',
  },
  copy: 'Entdecke die hochwertigen In-Ear-Kopfhörer, die sich automatisch mit Deinen verschiedenen Geräten verbinden.',
  cta: {
    label: 'Samsung Galaxy Buds entdecken',
    tag: 'nuxt-link',
    to: '/zubehoer/kopfhoerer/_samsung',
  },
  video: {
    src: `${videoPath}/32cf28b3baad7db964bcb8b28e3fc7a3/Samsung_Galaxy_Buds3.webm`,
    poster: `/_ipx/f_webp,w_640${imagePath}/hero-videos/6b35e55dd22dff9757156c12eb752309/samsung-galaxy-buds-3.png`,
  },
  hero: {
    align: 'center',
    src: `${imagePath}/hero-teaser/samsung-galaxy-buds/06075cd63ad940d9fdcb4d1743c19fa6/galaxy-buds-modelle-12-2024@2x.png`,
    alt: 'Vier Samsung Galaxy Buds Modelle in Ladehüllen.',
    animationProduct: {
      start: 'top bottom',
      end: 'center center',
      vars: { y: 150 },
    },
  },
};

export const COMPARISON_BUDS = {
  title: 'Finde Deine Kopfhörer',
  copy: 'Vergleiche hier die Top-Features unserer Galaxy Buds',
  items: [
    {
      title: 'Galaxy Buds3',
      headingTag: 'h4',
      products: [
        {
          alt: 'Galaxy Buds3 - silver',
          colorName: 'Silber',
          src: `${imagePath}/vergleichstabelle-buds/galaxy-buds3/gray/57bef95efb503eca8e2467d726db269e/samsung-galaxy-buds3-grau.png`,
          color: '#A5A9B4',
          articleNumber: '99935617',
          tileGroups: ['comparison_buds'],
        },
        {
          alt: 'Galaxy Buds3 - white',
          colorName: 'Weiß',
          src: `${imagePath}/vergleichstabelle-buds/galaxy-buds3/white/ac2411674d056949decea77ffc7d1fbe/samsung-galaxy-buds3-weiß.png`,
          color: '#FFFFFF',
          articleNumber: '8806095655659',
          tileGroups: ['comparison_buds'],
        },
      ],
      values: [
        {
          title: 'Soundqualität',
          content: '24-bit Hi-Fi 1-Weg-Lautsprecher',
          checked: false,
        },
        {
          title: 'ANC',
          content: '',
          checked: true,
          additionalInfo: '+ 3 Hohe SNR Mikrofone',
        },
        {
          title: 'Ambient sound',
          content: '',
          checked: true,
        },
        {
          title: 'Voice Detect',
          content: '',
          checked: false,
        },
        {
          title: '360 audio',
          content: '',
          checked: true,
        },
        {
          title: 'Wasserdicht',
          content: 'IP57',
          checked: false,
        },
        {
          title: 'Bluetooth ver.',
          content: '5.4',
          checked: false,
        },
        {
          title: 'SmartThings Find',
          content: '',
          checked: true,
        },
        {
          title: 'Auto switch',
          content: '',
          checked: true,
        },
        {
          title: 'Bixby Voice Wake-up',
          content: '',
          checked: true,
        },
        {
          title: 'Wiedergabezeit',
          content: 'Bis zu 5 Stunden (ANC an) Bis zu 6 Stunden (ANC aus)',
          checked: false,
        },
      ],
    },
    {
      title: 'Galaxy Buds3 Pro',
      headingTag: 'h4',
      products: [
        {
          alt: 'Galaxy Buds3 Pro - silver',
          colorName: 'Silber',
          src: `${imagePath}/vergleichstabelle-buds/galaxy-buds3-pro/gray/4912629534945a4141c0ccb0f82f1f45/samsung-galaxy-buds3-pro-grau.png`,
          color: '#A5A9B4',
          articleNumber: '99935615',
          tileGroups: ['comparison_buds'],
        },
        {
          alt: 'Galaxy Buds3 Pro - white',
          colorName: 'Weiß',
          src: `${imagePath}/vergleichstabelle-buds/galaxy-buds3-pro/white/8934aa1ebc297fc4f474b563166d4eef/samsung-galaxy-buds3-pro--weiß.png`,
          color: '#FFFFFF',
          articleNumber: '8806095661414',
          tileGroups: ['comparison_buds'],
        },
      ],
      values: [
        {
          title: 'Soundqualität',
          content: '24-bit Hi-Fi 2-Wege-Lautsprecher',
          checked: false,
        },
        {
          title: 'ANC',
          content: '',
          checked: true,
          additionalInfo: '+ 3 Hohe SNR Mikrofone',
        },
        {
          title: 'Ambient sound',
          content: '',
          checked: true,
        },
        {
          title: 'Voice Detect',
          content: '',
          checked: true,
        },
        {
          title: '360 audio',
          content: '',
          checked: true,
        },
        {
          title: 'Wasserdicht',
          content: 'IP57',
          checked: false,
        },
        {
          title: 'Bluetooth ver.',
          content: '5.4',
          checked: false,
        },
        {
          title: 'SmartThings Find',
          content: '',
          checked: true,
          additionalInfo: '+ Mit/ohne Ladeetui',
        },
        {
          title: 'Auto switch',
          content: '',
          checked: true,
        },
        {
          title: 'Bixby Voice Wake-up',
          content: '',
          checked: true,
        },
        {
          title: 'Wiedergabezeit',
          content: 'Bis zu 6 Stunden (ANC an) Bis zu 7 Stunden (ANC aus)',
          checked: false,
        },
      ],
    },
    {
      title: 'Galaxy Buds2 Pro',
      headingTag: 'h4',
      products: [
        {
          alt: 'Galaxy Buds2 Pro - borapurple',
          colorName: 'Borapurple',
          src: `${imagePath}/vergleichstabelle-buds/galaxy-buds2-pro/borapurple/d850730c94baedd12fffd4af4cc2a3d2/galaxy-buds2-pro-borapurple.webp`,
          color: '#ACA1BC',
          articleNumber: '8806094616439',
          tileGroups: ['comparison_buds'],
        },
        {
          alt: 'Galaxy Buds2 Pro - graphite',
          colorName: 'Graphite',
          src: `${imagePath}/vergleichstabelle-buds/galaxy-buds2-pro/graphite/4f3c943b05d4436651d6021b6fd57caa/galaxy-buds2-pro-graphite.webp`,
          color: '#2D2F35',
          articleNumber: '8806094521139',
          tileGroups: ['comparison_buds'],
        },
        {
          alt: 'Galaxy Buds2 Pro - white',
          colorName: 'White',
          src: `${imagePath}/vergleichstabelle-buds/galaxy-buds2-pro/white/3d342d2db7df0bfb6191f343c6c09989/galaxy-buds2-pro-white.webp`,
          color: '#F1F1F1',
          articleNumber: '8806094521085',
          tileGroups: ['comparison_buds'],
        },
      ],
      values: [
        {
          title: 'Soundqualität',
          content: '24-bit Hi-Fi 2-Wege-Lautsprecher',
          checked: false,
        },
        {
          title: 'ANC',
          content: '',
          checked: true,
          additionalInfo: '+ 3 Hohe SNR Mikrofone',
        },
        {
          title: 'Ambient sound',
          content: '',
          checked: true,
        },
        {
          title: 'Voice Detect',
          content: '',
          checked: true,
        },
        {
          title: '360 audio',
          content: '',
          checked: true,
          additionalInfo: '+ Unterstützt Direct Multi-Channel',
        },
        {
          title: 'Wasserdicht',
          content: 'IPX7',
          checked: false,
        },
        {
          title: 'Bluetooth ver.',
          content: 'Ver5.3',
          checked: false,
        },
        {
          title: 'SmartThings Find',
          content: '',
          checked: true,
          additionalInfo: '+ Mit/ohne Ladeetui',
        },
        {
          title: 'Auto switch',
          content: '',
          checked: true,
        },
        {
          title: 'Bixby Voice Wake-up',
          content: '',
          checked: true,
        },
        {
          title: 'Wiedergabezeit',
          content: 'Bis zu 5 Stunden (ANC an) Bis zu 8 Stunden (ANC aus)',
          checked: false,
        },
      ],
    },
  ],
};

type SamsungPromotion = Promotion<any>;

const TEASER_DATA: SamsungPromotion[] = [
  {
    tileGroups: ['smartphones'],
    articleNumber: '99936175',
    title: 'Samsung Galaxy S25 Ultra',
    showLocalTitle: true,
  },
  {
    subtitle: '',
    tileGroups: ['smartphones'],
    articleNumber: '99936143',
    title: 'Samsung Galaxy S25',
    showLocalTitle: true,
  },
  {
    tileGroups: ['family_first'],
    articleNumber: '99936212',
    title: 'Samsung Galaxy S25+',
    showLocalTitle: true,
  },
  {
    tileGroups: ['family_first'],
    articleNumber: '99935105',
    title: 'Samsung Galaxy s24 Ultra',
    showLocalTitle: true,
  },
  {
    tileGroups: ['family_second'],
    articleNumber: '8806095662121',
    title: '	Samsung Galaxy Watch7',
    showLocalTitle: true,
  },
  {
    tileGroups: ['family_third'],
    articleNumber: '99935615',
    title: 'Samsung Galaxy Buds3 Pro',
    showLocalTitle: true,
  },
];

export type WatchVariantMatchOfferType = {
  articleNumber: string;
  image: string;
  default?: boolean;
};

export type WatchVariantMatchType = {
  directory: string;
  offer: WatchVariantMatchOfferType[];
};

export type WatchVariantType = {
  articleNumber: string;
  image: string;
  upgrade: string;
  match: WatchVariantMatchType[];
};

export type WatchType = {
  directory: string;
  watchModel: number | undefined;
  variants: WatchVariantType[];
};

export type BraceletVariantType = {
  articleNumber: string;
  upgrade?: string;
};

export type BraceletType = {
  directory: string;
  copy: string;
  variants: BraceletVariantType[];
};

export const PRODUCT_DATA: SamsungPromotion[] = [
  ...TEASER_DATA,
  ...COMPARISON_WATCHES.items.flatMap(
    (item) =>
      item.products.filter((product) => product?.articleNumber) ||
      item.productsBig?.filter((product) => product?.articleNumber)
  ),
  ...COMPARISON_BUDS.items.flatMap((item) =>
    item.products.filter((product) => product?.articleNumber)
  ),
];

export const TEASER_BANNER = [
  {
    background: {
      src: `${imagePath}/banner/fa2e71b6e7a8908b48e3ba127cc3eb61/samsung-smartphones.png`,
      alt: 'Zwei Samsung Galaxy Smartphones – Galaxy A53 5G und Galaxy XCover6 Pro.',
      sizes: 'xs:100vw sm:50vw lg:50vw',
      style: 'aspect-ratio: 512 / 321;',
    },
    title: 'Entdecke die Samsung Galaxy Smartphones',
    button: {
      url: '/smartphones-und-handys/smartphones/_samsung',
      label: 'Zu den Smartphones',
    },
  },
  {
    background: {
      src: `${imagePath}/banner/be2e3babda125dbd0a4afe3b015473d4/samsung-zubehoer.png`,
      alt: 'Samsung Zubehör: Galaxy Buds, S Pen und eine braune Smartphone-Schutzhülle.',
      sizes: 'xs:100vw sm:50vw lg:50vw',
      style: 'aspect-ratio: 512 / 321;',
    },
    title: 'Entdecke das komplette Samsung Zubehör',
    button: {
      url: '/zubehoer/_samsung',
      label: 'Zum Zubehör',
    },
  },
];
